import React from 'react'
import { IonContent, IonLabel, IonRow, IonSpinner } from '@ionic/react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { getPulsaraCurrentStep, getPulsaraCurrentSubStep, getPulsaraLoading } from '../selectors'
import { PATIENT_MATCH_SUB_STEP_IDS, STEP_IDS } from '../constants'
import PulsaraList from './dashboard/PulsaraList.component'
import './Pulsara.content.css'
import PatientSearchContent from '../../patientSearch/pageContent/PatientSearch.content'
import PatientSearchResultsContent from '../../patientSearch/pageContent/PatientSearchResults.content'
import PatientConflict from './patientConflict/PatientConflict.component'
import PulsaraImport from './importStep/PulsaraImport.component'

const PulsaraContent: React.FC = () => {
  const { t } = useTranslation()
  const currentStep = useSelector(getPulsaraCurrentStep)
  const currentSubStep = useSelector(getPulsaraCurrentSubStep)
  const loading = useSelector(getPulsaraLoading)

  const renderLoader = () => {
    return currentStep === STEP_IDS.PULSARA_SEARCH ? (
      <IonRow className='ion-no-padding'>
        <IonSpinner data-testid='PulsaraSpinner' className='pulsara-loader' />
        <IonLabel className='text-align-center w-100 pt-5'>{t('pulsara.loading.loadingPulsaraData')}</IonLabel>
      </IonRow>
    ) : (
      <></>
    )
  }

  const renderPulsaraSearchSubStep = () => {
    switch (currentSubStep) {
      case PATIENT_MATCH_SUB_STEP_IDS.PATIENT_SEARCH_FORM:
        return <PatientSearchContent />
      case PATIENT_MATCH_SUB_STEP_IDS.PATIENT_SEARCH_RESULTS:
        return <PatientSearchResultsContent />
      case PATIENT_MATCH_SUB_STEP_IDS.PATIENT_CONFLICT:
        return <PatientConflict />
      default:
        return null
    }
  }

  const renderStepContent = () => {
    switch (currentStep) {
      case STEP_IDS.PULSARA_SEARCH:
        return <PulsaraList />
      case STEP_IDS.PATIENT_MATCH:
        return renderPulsaraSearchSubStep()
      case STEP_IDS.IMPORT:
        return <PulsaraImport />
      default:
        return null
    }
  }

  return (
    <IonContent className='ion-no-padding'>{loading === 'records' ? renderLoader() : renderStepContent()}</IonContent>
  )
}

export default PulsaraContent
